import React, {useEffect, useState} from 'react';
import Centered from "../../../layouts/centered";
import CenteredForm from "../../../layouts/centered-form";
import {useParams} from "react-router-dom";
import {Form} from "react-final-form";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {EnigooTextField} from "../../../MyComponent/EnigooTextField";
import EnigooButton from "../../../MyComponent/EnigooButton";
import {FiSend} from "react-icons/fi";
import {apiPostPassLinkAuthorize, apiPostRenewPassword} from "./Actions";
import CogoToast from "cogo-toast";
import EnigooDarkModeSwitch from "../../../MyComponent/EnigooDarkModeSwitch";
import EnigooLanguageDropDown from "../../../MyComponent/EnigooMultiLanguageField/EnigooLanguageDropDown";
import {EnigooEmailField} from "../../../MyComponent/EnigooEmailField";


const NewPassword = () => {
    let [saving, setSaving] = useState(false);
    let [loading, setLoading] = useState(false);
    const {passwordLink} = useParams();
    const history = useHistory();
    const {t} = useTranslation();

    const changePassword = (values) => {
        console.log(values);
        let newValues = values;
        newValues.passwordLink = passwordLink;
        setSaving(true);
        apiPostRenewPassword(newValues,(data)=>{
                CogoToast.success(t("basics.passwordSuccessfullyChanged"))
            history.push("/login");
            setSaving(false);
        },(err)=>{

            setSaving(false);
        })
    }

    if (!passwordLink) {
        history.push("/login");
    }

    useEffect(() => {
        setLoading(true);
        apiPostPassLinkAuthorize({"passwordLink": passwordLink}, (data) => {
            setLoading(false);
        }, (err) => {
            setLoading(false);
            CogoToast.error(t("basics.enteredLinkNotExist"));
            history.push("/login");
        })
    }, [])


    return <>
        <div className={"w-full flex fixed"}>
                    <span className={"ml-auto mr-3 flex flex-row space-x-2"}>
                        <div className={"flex content-center mt-auto"}> <EnigooDarkModeSwitch/></div>
                    <EnigooLanguageDropDown loginPage={true} type={"login"}/>
                        </span>
        </div>
        <Centered heading={true}>

            <CenteredForm subtitle={t("basics.enterNewPassword")} title={t("basics.renewPassword")}>
                <Form onSubmit={changePassword} validate={(values) => {
                    let error = {};
                    if (!values.email) {
                        error.email = t("basics.requireField");
                    }
                    if (!values.password) {
                        error.password = t("basics.requireField");
                    }
                    if (!values.confirmPassword) {
                        error.confirmPassword = t("basics.requireField");
                    }
                    if (values.password && values.confirmPassword && values.password !== values.confirmPassword) {
                        error.confirmPassword = t("basics.passwordsNotSame")
                    }
                    return error;
                }} render={({handleSubmit, values}) => {
                    return (
                        <div className={"flex flex-col space-y-2 w-full"}>
                            <EnigooEmailField mandatory={true} label={t("basics.email") + ": *"} name={"email"}
                                             placeHolder={"example@enigoo.cz"}/>
                            <EnigooTextField label={t("basics.newPassword") + ": *"} name={"password"} type={"password"}
                                             placeHolder={"******"}/>
                            <EnigooTextField label={t("basics.newPasswordConfirm") + ": *"} name={"confirmPassword"}
                                             type={"password"} placeHolder={"******"}/>
                            <EnigooButton icon={<FiSend/>} disabled={saving} loading={saving} text={t("basics.send")} onClick={()=>handleSubmit()}/>

                        </div>)
                }
                }/>
            </CenteredForm>
        </Centered>
    </>

}
NewPassword.propTypes = {}

export default NewPassword;
